import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import Alert, { Color } from '@material-ui/lab/Alert';

interface PropTypes {
  open?: boolean,
  type?: Color,
  message?: string
}

const SnackbarStateless:React.FunctionComponent<PropTypes> = (props: PropTypes) => {
  const {
    open: isOpen = false,
    type = 'success',
    message = '',
  } = props;
  const mounted = React.useRef(false);
  const [open, setOpen] = React.useState(false);
  React.useEffect(() => {
    if (mounted.current) {
      setOpen(!open);
    } else {
      mounted.current = true;
    }
  }, [isOpen]);
  return (
    <>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        open={open}
        autoHideDuration={3000}
        onClose={() => setOpen(false)}
      >
        <Alert
          severity={type}
          style={{
            boxShadow: '0 4px 20px 0 #0000000d',
            maxHeight: '28px',
            paddingTop: '2px',
            fontFamily: 'Montserrat Bold',
          }}
        >
          {message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default SnackbarStateless;
